import { useMutation } from '@tanstack/react-query';
import { AnytimeProductType } from '../Queries/useAnytimeProductList';
import {
	initiateAnytimeTransaction,
	InitiateTransactionResponse,
} from 'Services/Api/_HumanWritten/AnytimeTicketService';
import alertToast from 'Util/ToastifyUtils';

/**
 * Hook to initiate an anytime ticket purchase transaction.
 * Uses the server-side API to create a pending transaction.
 */
export const useInitiateAnytimeTransaction = (options?: {
	onSuccess?: (data: InitiateTransactionResponse) => void;
}) => {
	return useMutation<
		InitiateTransactionResponse,
		Error,
		{ productId: string; productType?: AnytimeProductType; customerId?: string | null; quantity: number }
	>({
		mutationFn: async ({
			productId,
			productType = 'TICKET',
			customerId,
			quantity,
		}): Promise<InitiateTransactionResponse> => {
			return initiateAnytimeTransaction(productId, productType, customerId, quantity);
		},
		onSuccess: data => {
			options?.onSuccess?.(data);
		},
		onError: error => {
			alertToast('Failed to start transaction. Please try again.', 'error');
		},
	});
};
